<button type="button" [attr.aria-label]="'common.scrollToTop' | translate" class="button-back scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}" mat-icon-button (click)="gotoTop()"><mat-icon>expand_less</mat-icon></button>
